'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BundlePage = require('./BundlePage');

var _PlanButton = require('./PlanButton');

var _PlanButton2 = _interopRequireDefault(_PlanButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarketingPlanButton = function MarketingPlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var marketingPlanSelected = state.marketingPlanSelected;

  var onSelectedChange = function onSelectedChange() {
    var updatedSelectedMerch = marketingPlanSelected === merchandiseId ? null : merchandiseId;
    mergeState({
      marketingPlanSelected: updatedSelectedMerch,
      marketingUnits: 0
    });
  };

  return _react2.default.createElement(_PlanButton2.default, {
    edition: edition,
    merchandiseId: merchandiseId,
    selected: marketingPlanSelected === merchandiseId,
    onSelectedChange: onSelectedChange
  });
};

exports.default = MarketingPlanButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/MarketingPlanButton.js
// module id = 684
// module chunks = 3 4